import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { TranslationScopeLoaderService } from './translation-scope-loader.service';

/**
 * Provide transloco `APP_INITIALIZER`, which will await translations being loaded
 * before proceeding to the application.
 */
export function provideTranslationScopeLoaderInitializer(): EnvironmentProviders {
	return provideAppInitializer(() => {
		const initializerFn = translationScopeLoaderInitializer(inject(TranslationScopeLoaderService));
		return initializerFn();
	});
}

function translationScopeLoaderInitializer(scopeLoader: TranslationScopeLoaderService): () => Promise<void> {
	return () => scopeLoader.start();
}
